import { useCallback, useEffect, useMemo, useState } from "react";
import { useRouter } from "next/router";
import CookieConsent from "./CookieConsent";
import EngagingPopup from "./EngagingPopup";
import HomePageEnquiryPopup from "./HomePageEnquiryPopup";
import { shouldSkipSitePopups } from "@/utils/sitePopups";

const SCROLL_THRESHOLD = 0.5;

function hasReachedScrollThreshold() {
  const doc = document.documentElement;
  const scrollTop = window.scrollY || doc.scrollTop;
  const maxScroll = doc.scrollHeight - window.innerHeight;

  if (maxScroll <= 0) return false;
  return scrollTop / maxScroll >= SCROLL_THRESHOLD;
}

export default function SiteOverlays() {
  const router = useRouter();
  const [enquiryOpen, setEnquiryOpen] = useState(false);

  const skipPopups = useMemo(
    () => shouldSkipSitePopups(router.asPath || router.pathname || "/"),
    [router.asPath, router.pathname]
  );

  useEffect(() => {
    setEnquiryOpen(false);

    if (skipPopups) {
      return undefined;
    }

    const openEnquiry = () => {
      setEnquiryOpen(true);
    };

    const handleScroll = () => {
      if (hasReachedScrollThreshold()) {
        openEnquiry();
        window.removeEventListener("scroll", handleScroll);
      }
    };

    if (hasReachedScrollThreshold()) {
      openEnquiry();
      return undefined;
    }

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [router.asPath, skipPopups]);

  const handleEnquiryClose = useCallback(() => {
    setEnquiryOpen(false);
  }, []);

  if (skipPopups) return null;

  return (
    <>
      <CookieConsent />
      <EngagingPopup />
      <HomePageEnquiryPopup open={enquiryOpen} onClose={handleEnquiryClose} />
    </>
  );
}
